export class Answer {
    public answer: string | null = null;
    public correctAnswer?: string;
    private isCorrectManual?: boolean = undefined;

    constructor(answer: string | null = null, correctAnswer?: string) {
        this.answer = answer;
        this.correctAnswer = correctAnswer;
    }

    public isCorrect() {
        if (this.isCorrectManual) {
            return this.isCorrectManual;
        }
        return this.answer === this.correctAnswer;
    }

    public isManuallyCorrect(isCorrect?: boolean) {
        this.isCorrectManual = isCorrect;
    }
}
